import React, { Fragment, useContext, useState } from "react";
import { Request } from "../../api/eklok/Eklok.api";
import Error from "../../components/Error";
import LoadingBackdrop from "../../components/LoadingBackdrop";
import Success from "../../components/Success";
import { AuthContext } from "../../context/auth/AuthContext";

const DeleteEklokContainer = ({ eklok, handleClose = () => {}, children }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = () => {
    setError(null);
    setLoading(true);
    Request.deleteEklok(token.access, { eklok: eklok.id })
      .then((data) => onSuccess(data))
      .catch((error) => onFailure(error));
  };

  const onSuccess = () => {
    setLoading(false);
    setSuccess(true);
  };

  const onFailure = (error) => {
    setError(error);
    setLoading(false);
  };

  const onCloseSuccesPopup = () => {
    setSuccess(null);
    handleClose();
  };

  const onCloseErrorPopup = () => {
    setError(null);
    handleClose();
  };

  return (
    <Fragment>
      {error ? <Error message={error} onClose={onCloseErrorPopup} /> : null}
      {loading && <LoadingBackdrop />}
      {success ? (
        <Success
          message="Eklok has been removed."
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {children({ onSubmit })}
    </Fragment>
  );
};

export default DeleteEklokContainer;
